import { ClientConfigDto } from '../services/service';

class Settings {
    public ClientId: string | undefined;
    public Domain: string | undefined;
    public Audience: string | undefined;
    public Production: boolean | undefined;
    public AppInsightsConnectionString: string | undefined;
    public BootstrapClientId: string | undefined;

    public setSettings(settings: ClientConfigDto) {
        this.Production = settings.production;
        this.ClientId = settings.clientId;
        this.Domain = settings.domain;
        this.Audience = settings.audience;
        this.AppInsightsConnectionString = settings.appInsightsConnectionString;
        this.BootstrapClientId = settings.bootstrapClientId;
    }
}

export default new Settings();